export enum PalantirAvatarSizeEnum {
  '2xl' = '2xl',
  '2xs' = '2xs',
  '3xs' = '3xs',
  '4xs' = '4xs',
  '5xs' = '5xs',
  'md' = 'md',
  'xl' = 'xl',
  'xs' = 'xs',
}

export type PalantirAvatarSize = keyof typeof PalantirAvatarSizeEnum;

export enum PalantirAvatarShapeEnum {
  'avatar' = 'avatar',
  'thumbnail' = 'thumbnail',
}

export type PalantirAvatarShape = keyof typeof PalantirAvatarShapeEnum;
